import * as React from 'react';
//import './index.css';
import { GridComponent, ColumnsDirective, ColumnDirective, Page, Toolbar, Edit, Inject, Sort, Filter, Resize, ForeignKey, DetailRow} from '@syncfusion/ej2-react-grids';
import { /* config, */ CustomWebApiAdaptor} from '../../../_helpers'
import { authenticationService } from '../../../_services'
import { SampleBase } from '../../../syncfusion/sample-base';
import { DataManager, Query, Predicate, DataUtil } from '@syncfusion/ej2-data';
import { setCulture,loadCldr,L10n  } from '@syncfusion/ej2-base';
import * as gregorian from 'cldr-data/main/es-CO/ca-gregorian.json';
import * as numbers from 'cldr-data/main/es-CO/numbers.json';
import * as timeZoneNames from 'cldr-data/main/es-CO/timeZoneNames.json';
import * as numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
import * as weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week
import * as L10n_es from '@syncfusion/ej2-locale/src/es.json'

setCulture("es-CO");
L10n.load({"es-CO":L10n_es.es});
DataUtil.serverTimezoneOffset = -5;

let CfgOptions;
let g_url;
let g_valorpk;
        
export class gridTable extends SampleBase {
    constructor() {
        super(...arguments);
        this.state = {loading:true};
        this.toolbarOptions = ['Add', 'Edit', 'Delete', 'Update', 'Cancel'];
        this.editSettings = { allowEditing: true,
                              allowAdding: true, 
                              allowDeleting: true, 
                              mode: 'Normal', 
                              showDeleteConfirmDialog: true };
        this.formatDate = {type:'date',  format:'M/d/y'};
        this.editparams = { params: { popupHeight: '300px', locale: "es-CO", format:'M/d/y', type:'date', placeholder: "Elige una fecha" }};
        this.validationRules = { required: true };
        this.validationERules = { required: true, email: true };
        this.validationNRules = { required: true, number: true };
        this.validationDRules = { required: true, date: true }
        this.pageSettings = { pageCount: 5, pageSize: 12, pageSizes: false };
        this.sortingOptions = { columns: [ { field: 'fecha_inicio', direction: 'Descending' }] };
        this.filterSettings = { type: 'Excel' };
        //this.filterSettings = { type: 'Menu'};
        //this.filterSettings = { type: 'CheckBox'};
        
        this.filter = {ui:{create:this.createFilter.bind(this)}}

        //this.predicate = new Predicate('fecha_inicio', 'equal', '2020-08-01');

        //this.query = new Query().sortByDesc('fecha_inicio').where(this.predicate);
        this.query = {}
        
        CfgOptions = authenticationService.currentUserValue.usuario.configuracion.replace(/'/g,"\"");
        CfgOptions = CfgOptions.replace(/: False/g,": false");
        CfgOptions = CfgOptions.replace(/: True/g,": true");
        CfgOptions = JSON.parse(CfgOptions).gridtable[authenticationService.currentUserValue.usuario.idioma];
        if (!CfgOptions[this.props.opcion].puerto) {
          CfgOptions[this.props.opcion].puerto = '5002';
        }
        this.tableColumnListColor = [{"color":'red',"colortext":'Rojo'},{"color":'green',"colortext":'Verde'},{"color":'blue',"colortext":'Azul'}]
        //debugger;
        this.config = window.config;                                
        this.predicateColumns = new Predicate('tabname','equal',CfgOptions[this.props.opcion].tabla);
        this.predicateColumns = this.predicateColumns.and('tabschema','equal',CfgOptions[this.props.opcion].esquema)
        this.firtsQuery = 0;
        // this a sessionStorage
        this.cfgTable = new DataManager({ url: JSON.parse(sessionStorage.config).HostUrl + CfgOptions['catalogo_tab'].puerto + JSON.parse(sessionStorage.config).HostEndUrl + CfgOptions['catalogo_tab'].endpoint, 
                                      headers:[{ "Content-Type":  "application / json",
                                                  "api-token": `${authenticationService.currentUserValue.jwt_token}`
                                                }],
                                      adaptor: new CustomWebApiAdaptor() ,
                                      crossDomain: true}) 
                                      .executeQuery(new Query().where(this.predicateColumns).page(1,100))
                                      .then(resp=>{
                                        
                                        this.cfgTable = resp.actual.data[0];
                                        //console.log('Tabla resul')
                                        //console.log(this.cfgTable)
                                        this.firtsQuery++;
                                        if (this.firtsQuery === 2) {
                                          this.cargaDatosAdic();
                                          //this.setState({loading:false})
                                        }
                                        //else { }
                                        return resp.actual.data[0];
                                      });  
        // this a sessionStorage
        this.columnsTable = new DataManager({ url: JSON.parse(sessionStorage.config).HostUrl + CfgOptions['catalogo_col'].puerto + JSON.parse(sessionStorage.config).HostEndUrl + CfgOptions['catalogo_col'].endpoint, 
                                      headers:[{ "Content-Type":  "application / json",
                                                  "api-token": `${authenticationService.currentUserValue.jwt_token}`
                                                }],
                                      adaptor: new CustomWebApiAdaptor() ,
                                      crossDomain: true}) 
                                      .executeQuery(new Query().where(this.predicateColumns).sortBy('columnid','ascending').page(1,100))
                                      .then(resp=>{
                                        
                                        this.columnsTable = resp;
                                        console.log('Columnas resul')
                                        console.log(this.columnsTable)  
                                        this.firtsQuery++;
                                        if (this.firtsQuery === 2) {
                                          this.cargaDatosAdic();
                                          this.setState({loading:false})
                                        }
                                        //else { this.firtsQuery++}
                                        return resp;
            
                                      });  
        //console.log('Tabla')
        //console.log(this.cfgTable)  
          
        
        /* this.tableColumnList = new DataManager({ url: config.HostUrl + CfgOptions['clientes'].puerto + config.HostEndUrl + CfgOptions['clientes'].endpoint, 
                               headers:[{ "Content-Type":  "application / json",
                                          "api-token": `${authenticationService.currentUserValue.jwt_token}`
                                        }],
                               adaptor: new CustomWebApiAdaptor() ,
                               crossDomain: true})
                               .executeQuery(new Query().page(1,10000))
                                      .then(resp=>{
                                        
                                        this.tableColumnList = resp;
                                        this.firtsQuery++;
                                        if (this.firtsQuery === 2) {
                                          this.cargaDatosAdic();
                                          //this.setState({loading:false})
                                        }
                                        //else { this.firtsQuery++}
                                        return resp;
            
                                      }); */
        //console.log('configuracion grid table')
        //console.log(sessionStorage.config)
        //console.log(JSON.parse(sessionStorage.config).HostUrl)
        //console.log(CfgOptions[this.props.opcion].puerto)
        //console.log(JSON.parse(sessionStorage.config).HostEndUrl)
        //console.log(CfgOptions[this.props.opcion].endpoint)
        //console.log(this.props.opcion)
        this.template = this.gridTemplate;

        //this a sessionStorage
        g_url = JSON.parse(sessionStorage.config).HostUrl + CfgOptions[this.props.opcion].puerto + JSON.parse(sessionStorage.config).HostEndUrl + CfgOptions[this.props.opcion].endpoint;
        this.data = new DataManager({ url: JSON.parse(sessionStorage.config).HostUrl + CfgOptions[this.props.opcion].puerto + JSON.parse(sessionStorage.config).HostEndUrl + CfgOptions[this.props.opcion].endpoint, 
                                      headers:[{ "Content-Type":  "application / json",
                                                  "api-token": `${authenticationService.currentUserValue.jwt_token}`
                                                }],
                                      adaptor: new CustomWebApiAdaptor() ,
                                      timeZoneHandling: false,
                                      crossDomain: true});  
        //debugger;
        //console.log('URL')
        //console.log(g_url);
        //console.log('Datos');
        //console.log(this.data);
        

    }

    cargaDatosAdic () {
      //g_config = this.config;
      
      if (this.cfgTable.numforeingkey === 0) {
        this.setState({loading:false});
      } else {
        let firtsQuery=0;
        let v_foreignData = {foreign: {}};
        let v_numForeignKey = this.cfgTable.numforeingkey;
        this.columnsTable.actual.data.map(key  => {
          if (key.foreignkey === true) {
            //this a sessionStorage
            this.tableForeignData = new DataManager({ url:JSON.parse(sessionStorage.config).HostUrl + CfgOptions[key.foreignkeytable].puerto + JSON.parse(sessionStorage.config).HostEndUrl + CfgOptions[key.foreignkeytable].endpoint, 
                                      headers:[{ "Content-Type":  "application / json",
                                                "api-token": `${authenticationService.currentUserValue.jwt_token}`
                                              }],
                                      adaptor: new CustomWebApiAdaptor() ,
                                      crossDomain: true})
                                      .executeQuery(new Query().page(1,10000))
                                            .then(resp=>{
                                        
                                              v_foreignData.foreign[key.foreignkeytable] = resp.actual.data;
                                              firtsQuery++;
                                              if (firtsQuery === v_numForeignKey) {
                                                this.foreignData = v_foreignData;
                                                this.setState({loading:false});
                                              }
                                              return resp;

                                            });
          }
          return true;
        })
      
      }
    }

    onClickTabla () {
      console.log('click tabla');
      console.log(this.gridObj);
   
    }
    onActionComplete(args) {
     
      if(args.requestType === "delete"){
          alert("Registro Borrado Exitosamente");
          var grid = document.getElementsByClassName('e-grid')[0].ej2_instances[0] ;
          grid.dataSource.dataSource.url = g_url;
      } /* else {
          if (args.requestType === "filtering") {
            this.gridObj.dataSource.requestType = ''
          }
      } */
    }

    onActionFailure(args) {
    
    
      var grid = document.getElementsByClassName('e-grid')[0].ej2_instances[0] 
      
      let primary=false;
      let campo = "";
        
      this.columnsTable.actual.data.map(key => { 
        if (!primary && key.isprimarykey === true) {
          primary = true;
          campo = key.columnname;
          return true;
        }
        return false;
      });
      if ( campo !== "" ) {
        grid.selectionModule.data[campo] = g_valorpk
      }

   /*    if (args.requestType === "filtering") {
        this.gridObj.dataSource.requestType = ''
      } */
      
      grid.dataSource.dataSource.url = g_url;
      console.log('fallo');
      console.log(args);
    }

    createFilter (args) {
      
    }

    onBeforeBatchDelete(args) {
     
    }

    onActionBegin(args) {
      var grid = document.getElementsByClassName('e-grid')[0].ej2_instances[0] 
      grid.dataSource.optionRequest = args.requestType
      
      if (args.requestType === 'delete') {
        
        let primary=false;
        let campo = "";
        let largo = grid.dataSource.dataSource.url.length
        grid.dataSource.dataSource.url = grid.dataSource.dataSource.url.substring(0,largo-1);
        grid.dataSource.dataSource.selectedData = JSON.stringify(grid.selectionModule.data);
        this.columnsTable.actual.data.map(key => { 
          if (!primary && key.isprimarykey === true) {
            primary = true;
            campo = key.columnname;
            return true;
          } 
          return false;
           /* grid.columns[key.columnid-1].isPrimaryKey = false; */
        })
        g_valorpk = "";
        if ( campo !== "" ) {
          g_valorpk = args.data[0][campo];
          args.data[0][campo] = "" ;
        }

      } else {
      if (args.requestType === "save") { 
        this.columnsTable.actual.data.map(key => {
          if (key.columntype === 'date' || key.columntype === 'datetime') {
            var dateObject = args.data[key.columnname]; 
            args.data[key.columnname] = 
              dateObject.getFullYear() +
              "/" + 
              (dateObject.getMonth()+1).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false}) + 
              "/" + 
              dateObject.getDate().toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false});
            if (key.columntype === 'datetime') {
              args.data[key.columnname] = args.data[key.columnname] + "T" + dateObject.getHours().toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})
                                          + ":" +
                                          dateObject.getMinutes().toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})
                                          + ":" +
                                          dateObject.getSeconds().toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false});
            }
          }
          return true;
        })
      } 
      else if (args.requestType === "filtering") {
        grid.dataSource.currentFilterObject = args.currentFilterObject;
        //grid.dataSource.requestType = args.requestType;
        grid.dataSource.columnType = grid.filterModule.column.type;

        /* if (args.currentFilterObject.field === "markdate") {
          //grid.filterModule.actualPredicate.markdate[0]
          let dateObject = args.currentFilterObject.value;
          args.currentFilterObject.value = dateObject.getFullYear() +
                                            "/" + 
                                            (dateObject.getMonth()+1).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false}) + 
                                            "/" + 
                                            dateObject.getDate().toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false});
          args.columns[0].properties.value = args.currentFilterObject.value;
          this.gridObj.filterModule.value = args.currentFilterObject.value;
        
        } */
      } /* else if (args.requestType === "filtersearchbegin") {
        grid.dataSource.filterSearch = true;
      } */
      }
    }

    onDataBound(args) {
      
    }

    render() { 

        debugger;

        loadCldr(numberingSystems.default, gregorian.default, numbers.default, timeZoneNames.default, weekData.default);
        let v_detailTemplate = null
        if ( this.state && this.state.loading===false && this.cfgTable.imagesincluded===true) {
          v_detailTemplate = this.template.bind(this);
        }
        console.log('Columnas render')
        console.log(this.columnsTable) 
        console.log('this')
        console.log(this)  
        return (<div className='control-pane'>
                <div className='control-section' style={{ height: "90%", width: "95%" }}>
                  {this.state && this.state.loading===false &&
                  <GridComponent className='e-grid' dataSource={this.data} locale='es-CO' toolbar={this.toolbarOptions} 
                        allowPaging={true} 
                        editSettings={this.editSettings} query={this.query} 
                        actionFailure={this.onActionFailure.bind(this)} actionBegin={this.onActionBegin.bind(this)}
                        filter={this.filter}
                        beforeBatchDelete={this.onBeforeBatchDelete.bind(this)}
                        allowSorting={true} allowMultiSorting={true} 
                        sortingOptions = {this.sortingOptions}
                        allowFiltering={true} filterSettings={this.filterSettings}
                        allowResizing={true}
                        /* toolbarClick={this.toolbarClick = this.toolbarClick.bind(this)} */
                        pageSettings={this.pageSettings} actionComplete = {this.onActionComplete = this.onActionComplete.bind(this)}
                        ref={(scope) => { this.gridObj = scope; }} onClick = {this.onClickTabla = this.onClickTabla.bind(this)}
                        beforeOpenColumnChooser = {this.onDataBound.bind(this)}
                        detailTemplate = {v_detailTemplate}
                        height={'440px'}>
                    <ColumnsDirective>
                       {this.columnsTable.actual.data.map(key => {
                          
                          //debugger;
                          console.log('ingreso')
                          let validationRules = {};
                            if (key.rulesrequired === true) {
                              validationRules.required = true;
                            }
                            if (key.rulesemail === true) {
                              validationRules.email = true;
                            } else {
                              if (key.rulesnumber===true) {
                                validationRules.number = true;
                              } else {if (key.rulesdate===true) {
                                validationRules.date = true;
                              }}
                            }
                            let editParams = { params: { popupHeight: key.paramspopupheight, locale: key.paramslocale, format:key.paramsformat, type:key.paramstype, placeholder: key.paramsplaceholder }};

                            //let format = { type: key.columntype, format: key.columnformat };
                            if (key.foreignkey === true) {
                              
                              //key.foreignTable = 'clientes'
                              
                              return  <ColumnDirective  field={key.columnname} headerText={key.columntext} 
                                                      type = {key.columntype}
                                                      width={key.columnwidth} 
                                                      isPrimaryKey={key.isprimarykey}
                                                      format={key.columnformat}
                                                      validationRules={validationRules} 
                                                      editType={key.columnedittype}
                                                      edit={editParams}
                                                      foreignKeyValue={key.foreignkeyvalue} 
                                                      foreignKeyField={key.foreignkeyfield}  
                                                      filter={{ui:{create:this.createFilter.bind(this)}}}
                                                      dataSource = {this.foreignData.foreign[key.foreignkeytable]}
                                                      >
    
                                    </ColumnDirective>
                            } else if (key.columnname === 'color') {
                                        key.foreignKeyValue = 'colortext';
                                        key.foreignKeyField = 'color'
                                        return  <ColumnDirective  field={key.columnname} headerText={key.columntext} 
                                                                type = {key.columntype}
                                                                width={key.columnwidth} 
                                                                isPrimaryKey={key.isprimarykey}
                                                                format={key.columnformat}
                                                                validationRules={validationRules} 
                                                                editType={key.columnedittype}
                                                                edit={editParams}
                                                                foreignKeyValue={key.foreignKeyValue} 
                                                                foreignKeyField={key.foreignKeyField}  
                                                                dataSource = {this.tableColumnListColor}
                                                                >
              
                                              </ColumnDirective>
                            }
                            if (key.columntype === 'date'  || key.columntype === 'datetime') {
                              return  <ColumnDirective  field={key.columnname} headerText={key.columntext} 
                                                      type = {key.columntype}
                                                      width={key.columnwidth} 
                                                      isPrimaryKey={key.isprimarykey}
                                                      format={key.columnformat}
                                                      validationRules={validationRules} 
                                                      editType={key.columnedittype}
                                                      filter = {{type:"Menu"}}
                                                      edit={editParams}>
                                    </ColumnDirective>
                            }
                            return  <ColumnDirective  field={key.columnname} headerText={key.columntext} 
                                                      type = {key.columntype}
                                                      width={key.columnwidth} 
                                                      isPrimaryKey={key.isprimarykey}
                                                      format={key.columnformat}
                                                      validationRules={validationRules} 
                                                      editType={key.columnedittype}
                                                      edit={editParams}>

                                    </ColumnDirective>
                          })}         
                          {/*<ColumnDirective field='countryid' headerText='Codigo Pais' type='string' width='10' 
                          isPrimaryKey={false} format={null} validationRules={{required:true}} editType = {null}
                          edit={{params:{popupHeight:'150px', locale:'es-CO',format:null}}}></ColumnDirective>
                          <ColumnDirective field='name' headerText='Nombre del Pais' type='string' width='100' 
                          isPrimaryKey={false} format={null} validationRules={{required:true}} editType = {null}
                          edit={{params:{popupHeight:'150px', locale:'es-CO',format:null}}}></ColumnDirective>*/}
                           {/* <ColumnDirective field='projectid' headerText='ID Proyecto' type='number' width='10' 
                          isPrimaryKey={true} format={null} validationRules={{required:true, number:true}} editType = {null}
                          edit={{params:{popupHeight:'150px', locale:'es-CO',format:null}}}></ColumnDirective>
                          <ColumnDirective field='markdate' headerText='Fecha del marcador' type='date' width='30' 
                          isPrimaryKey={true} format={'MMM dd, y'} validationRules={{required:true, date:true}} editType = {'datepickeredit'}
                          edit={{params:{popupHeight:'150px', locale:'es-CO',format:'MMM dd, y'}}}></ColumnDirective>
                          <ColumnDirective field='marklabel' headerText='Nombre del Marcador' type='string' width='100' 
                          isPrimaryKey={false} format={null} validationRules={{required:true}} editType = {null}
                          edit={{params:{popupHeight:'150px', locale:'es-CO',format:null}}}></ColumnDirective> */}
                    </ColumnsDirective>
                    <Inject services={[Page, Toolbar, Edit, Sort, Filter, Resize, ForeignKey, DetailRow]}/>
                  </GridComponent> 
                  }
                </div>
              </div>);
        
        
    }

    gridTemplate(props) {
      
      //var src = require('../../../images/' + props.countryid + '.png');
      var src = require('../../../images/' + props[this.cfgTable.imagesfield] + '.png');

      return (<table className="detailtable" style={{ width: "100%" }}>
          <colgroup>
              <col style={{ width: "35%" }}/>
              <col style={{ width: "35%" }}/>
              <col style={{ width: "30%" }}/>
          </colgroup>
          <tbody>
              <tr>
                  <td rowSpan={4} className='images'>
                      <img className='photo' src={src} alt={props[this.cfgTable.imagesfield]}/>
                  </td>
              </tr>
          </tbody>
      </table>);
  }
}